import { useQuery } from '@tanstack/react-query';
import { fetchRepositories } from '../../../../api/administration/edmsSettings/repositories';

export const useRepositories = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['repositories', filters],
    queryFn: () => fetchRepositories(filters),
    keepPreviousData: true,
    enabled: options.enabled,
  });

  return {
    ...query,
    data: query.data?.data?.repositories ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.pageSize ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export default useRepositories;
